// LandingPage.js
import React from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";

function LandingPage() {
  return (
    <div className="landing-page">
      <h4>Hellooooo :) </h4>
      <p>we made you a christmas tree since you said you didn't have one. sorry it's a bit late!!</p>
      <Link to="/tree" className="start-button">
        click here to see 🎄
      </Link>
    </div>
  );
}

export default LandingPage;
